import {useGetInfiniteBasicDataItems} from '@/modules/basic-data/api'
import {getTradeNameFormDefaultValues} from '@/modules/products/trade-names/functions'
import {useGetSettings} from '@/modules/settings/api'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {FormGrid} from '@cypro/ui/components/ui/form-grid'
import {withForm} from '@cypro/ui/integrations/form'
import {BasicDataResources} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {LuBarcode} from 'react-icons/lu'
import {Box} from '@chakra-ui/react'

export const TradeNameLogisticsTab = withForm({
  defaultValues: getTradeNameFormDefaultValues(undefined),
  render: function Render({form}) {
    const {t} = useTranslate('common')
    const {t: tTradeNames} = useTranslate('trade-names')

    const infiniteCompanies = useGetInfiniteBasicDataItems({resource: BasicDataResources.companies})
    const {settings} = useGetSettings()

    return (
      <Box spaceY="8">
        <FormSection
          label={tTradeNames('logistics_national_codes')}
          description={tTradeNames('logistics_national_codes_description')}
        >
          <FormGrid>
            <form.AppField name="manufacturerId" mode="value">
              {field => (
                <field.InfiniteCombobox
                  size="sm"
                  label={t('manufacturer')}
                  placeholder={t('eg', {value: t('company')})}
                  {...infiniteCompanies}
                />
              )}
            </form.AppField>

            <form.AppField name="labelName">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('label_name')}
                  placeholder={tTradeNames('label_name_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="nationalId">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('national_id')}
                  placeholder={tTradeNames('national_id_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="atcCode">
              {field => (
                <field.TextField size="sm" label={t('atc_code')} placeholder={tTradeNames('atc_code_placeholder')} />
              )}
            </form.AppField>

            <form.AppField name="barcodeGtin">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('barcode_gtin')}
                  placeholder={tTradeNames('barcode_placeholder')}
                  inputGroupProps={{startElement: <LuBarcode />}}
                />
              )}
            </form.AppField>

            <form.AppField name="unitsPerPackage">
              {field => (
                <field.NumberInput
                  size="sm"
                  label={t('units_per_package')}
                  placeholder={tTradeNames('units_per_package_placeholder')}
                  min={1}
                />
              )}
            </form.AppField>

            <form.AppField name="minimumStock">
              {field => (
                <field.NumberInput
                  size="sm"
                  label={t('minimum_stock')}
                  placeholder={tTradeNames('minimum_stock_placeholder')}
                  min={0}
                />
              )}
            </form.AppField>

            <form.AppField name="externalInformationLink">
              {field => <field.TextField size="sm" label={t('external_information_link')} placeholder="https://" />}
            </form.AppField>

            <Box gridColumn="span 2">
              <form.AppField name="minimumSaveableVolume">
                {field => (
                  <field.NumberInput
                    size="sm"
                    label={t('settings.minimumSaveableVolume')}
                    helpText={tTradeNames('minimum_saveable_volume_help')}
                    placeholder={tTradeNames('minimum_saveable_volume_placeholder', {
                      value: settings?.minimumSaveableVolume ?? 10,
                    })}
                    allowEmpty
                    min={0}
                    max={100}
                    maxW="16rem"
                    inputGroupProps={{endElement: <Box paddingRight="1rem">%</Box>}}
                  />
                )}
              </form.AppField>
            </Box>
          </FormGrid>
        </FormSection>

        <FormSection label={tTradeNames('production_note')} description={tTradeNames('production_note_description')}>
          <FormGrid>
            <Box gridColumn="span 2">
              <form.AppField name="productionNotes">
                {field => (
                  <field.Textarea
                    size="sm"
                    label={tTradeNames('production_note')}
                    hideLabel
                    placeholder={tTradeNames('production_note_placeholder')}
                    rows={4}
                  />
                )}
              </form.AppField>
            </Box>
          </FormGrid>
        </FormSection>
      </Box>
    )
  },
})
